import { isQuotingToolAvailable } from 'modules/common/permissions';
import { ViewsEntry } from 'modules/views';

import { initRequote } from 'store/routeSagas';

import QuoteDetails from './quoteDetailsPage/entry';

export const quotesBaseRoute = '/quotes';

export default [
  {
    path: `${quotesBaseRoute}/:quoteId/requote`,
    saga: initRequote,
  },
  {
    path: [`${quotesBaseRoute}/create`, `${quotesBaseRoute}/edit/:quoteNumber`],
    component: QuoteDetails,
    permissions: [isQuotingToolAvailable],
  },
  {
    path: quotesBaseRoute,
    component: ViewsEntry,
    permissions: [isQuotingToolAvailable],
  },
];
